export class EvidenceRedactionRequest {
  constructor(public Description: string) {}
}

export class UpdateEvidenceRequest {
  constructor(
    public Title: string,
    public Tags: string[],
    public ActualFileDate: Date | null,
    public OrganisationalID: string | null,
    public Description: string,
    public Categories: string[]
  ) {}
}

export class VideosFilterRequest {
  constructor(
    public SelectedUsers: string[] | null,
    public SearchText: string,
    public DateFrom: string | null,
    public DateTo: string | null,
    public Skip: number,
    public Take: number,
    public SearchByActualFileDate: boolean,
    public OnlySharedWithMe: boolean = false
  ) {}
}

export class SetLocationRequest {
  constructor(public LocationLatitude: number, public LocationLongitude: number, public LocationAddress: string, public LocationDescription: string | null) {}
}

export class TrimEvidenceRequest {
  constructor(public StartSeconds: number, public EndSeconds: number) {}
}
